import { z } from "zod";
// v2 (P2): adds `jobId` so the DNA handler's legacy-path recovery can identify
// the attach emitted by THIS exact `dna-analysis` job — without `jobId`, a
// retry after a partial failure on a project with multiple legacy jobs could
// observe an attach from a DIFFERENT job and skip materialization. v1 events
// from before the bump are upcasted with `jobId: "legacy:unknown"` (see
// upcasters/dna-reference-attached-v1-to-v2.ts) — that sentinel never matches
// a real `job.id`, so the recovery degrades to "re-emit" for them, which is
// safe (the legacy reducer keeps a single legacy reference in place).
export const dnaReferenceAttachedPayloadSchema = z.object({
    jobId: z.string().min(1),
    bpm: z.number().positive().max(300),
    key: z.string().min(1),
    mood: z.string().min(1),
    attachedAt: z.string().datetime(),
});
//# sourceMappingURL=dna.js.map